

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.BYdUMUSw.js","_app/immutable/chunks/stores.C9Id2kgx.js","_app/immutable/chunks/client.CkwofkKx.js"];
export const stylesheets = [];
export const fonts = [];
